import { memo, useCallback, useEffect, useRef } from 'react';
import AnimateTop from 'components/AnimateTop';
import StepLayout from 'components/layout/StepLayout';
import { Formik, Form } from 'formik';
import { VALIDATION_STEP_3 } from 'utils/validations';
import { useDispatch, useSelector } from 'react-redux';
import { fillStep3Data } from 'store/slices/form.slice';
import { nextStep, prevStep } from 'store/slices/global.slice';
import { Step3Content } from './Step3.styled';
import BaseInput from 'components/common/BaseInput';
import Footer from 'components/footer/Footer';
import { FooterOkBtn, FooterPressText } from 'components/footer/Footer.styled';
import { HiOutlineCheck } from 'react-icons/hi';
import BaseTitle from 'components/common/BaseTitle';

const Step3 = () => {
  const { email } = useSelector((state) => state.form);
  const emailRef = useRef(null);
  const dispatch = useDispatch();

  const onSubmitStep3 = useCallback(
    async (values) => {
      localStorage.setItem("email", values.email);
      await dispatch(fillStep3Data(values));
      await dispatch(nextStep());
    },
    [dispatch]
  );

  useEffect(() => {
    if (emailRef.current && window.innerWidth > 768) emailRef.current.focus();
  }, [emailRef]);

  return (
    <AnimateTop>
      <StepLayout title="What's your email address?*">
        <Formik
          initialValues={{
            email: email,
          }}
          validationSchema={VALIDATION_STEP_3}
          onSubmit={onSubmitStep3}
        >
          {/* {({ isValid, dirty }) => ( */}
          <Form>
            <Step3Content>
              <BaseTitle type='subtitle' fw={500}>
                We promise not to spam you or sell your contact information.
              </BaseTitle>
              <BaseInput
                name='email'
                placeholder='name@example.com'
                ref={emailRef}
              />
            </Step3Content>
            <Footer prevArrowClick={() => dispatch(prevStep())}>
              <FooterOkBtn type='submit'>
                OK <HiOutlineCheck />
              </FooterOkBtn>
              <FooterPressText>press Enter ↵</FooterPressText>
            </Footer>
          </Form>
          {/* )} */}
        </Formik>
      </StepLayout>
    </AnimateTop>
  );
};

export default memo(Step3);
